import { Placeholder } from '@lmn/design-system';
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Separator } from '@/app/components/hotel-detail/rooms/RoomPanelMealPlanOptions';
import customCss from '@/app/components/hotel-detail/css/customCss';

export default function RoomPanelSkeleton() {
  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;
      `}
    >
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`room-paceholder-${index}`}
          css={css`
            display: flex;
            flex-direction: row;
            background-color: white;
            border-radius: 8px;
            box-shadow: ${({ theme }) => theme.kallisto.shadow.mediumDownShadow};
          `}
        >
          <div
            css={`
              width: 280px;
              display: flex;
              flex-direction: column;
              gap: 16px;
              margin: 24px;

              & > div:first-child {
                border-radius: 8px;
              }
            `}
          >
            <Placeholder width="280px" height="140px" />
            <Placeholder width="280px" height="20px" />
            <div
              css={`
                display: flex;
                flex-direction: column;
                gap: 8px;
              `}
            >
              <Placeholder width="280px" height="20px" />
              <Placeholder width="233px" height="20px" />
              <Placeholder width="128px" height="20px" />
            </div>
          </div>
          <VerticalSeparator />
          <div
            css={`
              padding: 24px;
              display: flex;
              flex: 1;
              flex-direction: column;
              gap: 16px;
            `}
          >
            <Placeholder width="94px" height="20px" />
            <Placeholder width="225px" height="20px" />
            <Placeholder width="225px" height="20px" />
            <Separator />
            <Placeholder width="94px" height="20px" />
            <Placeholder width="225px" height="20px" />
            <Placeholder width="225px" height="20px" />
          </div>
          <div
            css={`
              width: 280px;
              padding: 24px;
              display: flex;
              gap: 24px;
              flex-direction: column;
              align-items: flex-end;
              justify-content: flex-end;
              box-shadow:
                0px 0px 4px 0px #00000005,
                0px 0px 10px 0px #0000000a,
                0px 0px 20px 0px #0000000a;
            `}
          >
            <div
              css={`
                display: flex;
                gap: 8px;
                flex-direction: column;
                align-items: flex-end;
                justify-content: flex-end;
              `}
            >
              <Placeholder width="100px" height="26px" />
              <Placeholder width="150px" height="16px" />
            </div>
            <Placeholder width="100%" height="40px" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function RoomPanelSkeletonMobile() {
  return (
    <div
      css={`
        display: flex;
        flex-direction: column;
        gap: 16px;

        @media ${customCss.breakpoints.sm} {
          display: grid;
          grid-template-columns: 1fr 1fr;
        }
      `}
    >
      {Array.from({ length: 4 }).map((_, index) => (
        <div
          // eslint-disable-next-line react/no-array-index-key
          key={`room-paceholder-${index}`}
          css={css`
            display: flex;
            flex-direction: column;
            background-color: white;
            border-radius: 8px;
            box-shadow: ${({ theme }) => theme.kallisto.shadow.mediumDownShadow};
          `}
        >
          <div
            css={`
              height: 144px;
              width: 100%;
              border-radius: 8px;
            `}
          >
            <Placeholder width="100%" height="100%" />
          </div>
          <div
            css={`
              display: flex;
              flex-direction: column;
              width: 100%;
              gap: 4px;
              padding: 8px 16px 16px;
            `}
          >
            <Placeholder width="70%" height="20px" />
            <div
              css={`
                display: flex;
                flex-direction: row;
                width: 80%;
                gap: 4px;
              `}
            >
              <Placeholder width="35%" height="20px" />
              <Placeholder width="25%" height="20px" />
              <Placeholder width="40%" height="20px" />
            </div>
            <div
              css={`
                display: flex;
                flex-direction: row;
                width: 60%;
                gap: 4px;
              `}
            >
              <Placeholder width="70%" height="20px" />
              <Placeholder width="30%" height="20px" />
            </div>
            <div
              css={`
                display: flex;
                flex-direction: column;
                width: 70%;
                gap: 4px;
                margin-top: 20px;
              `}
            >
              <Placeholder width="85%" height="20px" />
              <Placeholder width="100%" height="20px" />
            </div>
            <div
              css={`
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                padding: 8px 0;
                gap: 4px;
                margin-top: 20px;
              `}
            >
              <Placeholder width="40%" height="26px" />
              <Placeholder width="50%" height="16px" />
            </div>
            <Placeholder width="100%" height="40px" />
          </div>
        </div>
      ))}
    </div>
  );
}

export const VerticalSeparator = styled.div`
  height: auto;
  border-left: 1px solid ${(p) => p.theme.commons.colors.gray100};
  margin: 24px 0;
`;
